import React from 'react';
import styled from 'styled-components';
import { bool } from 'prop-types';
import {HoverColor} from '../../Colors';

const DraggableItem = TargetComponent => {

	const Enhanced = styled(TargetComponent).attrs(
		{draggable : true}
	)`
        ${({isDragging})=> isDragging && `
			opacity:0.5;
			background-color : ${HoverColor};
        `}
    `;
	return function EnhancedComponent({isDragging,...props}){
		EnhancedComponent.propTypes = {
			isDragging: bool,
		};
		return (<Enhanced isDragging={isDragging} {...props}/>);
	};
};

export default DraggableItem;